import * as React from 'react';

const Hr24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#171796", d: "M3 14v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M21 10H3v4h18z" }), /* @__PURE__ */ React.createElement("path", { fill: "#D52B1E", d: "M5 6a2 2 0 0 0-2 2v2h18V8a2 2 0 0 0-2-2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#D52B1E",
    d: "M9.098 9.849v3.32c0 1.564 1.301 2.831 2.907 2.831s2.908-1.267 2.908-2.83V9.849z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M10.352 10.602h1.103v1.073h-1.103zm1.103 1.073h1.102v1.072h1.102v1.073h-1.102v-1.073h-1.102zm1.102 3.675c.34-.08.656-.24.926-.457h-.926V13.82h-1.102v1.073h1.102zm1.102-4.748h-1.102v1.073h1.102zm.551 3.218a2.14 2.14 0 0 1-.55.925l-.001-.925zm-4.408 0c.105.354.292.674.55.925v-.925zm-.117-2.145h.667v1.072h1.103v1.073h-1.103v-1.073h-.667z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M14.328 11.675h-.67v1.072h.67zm-2.873 3.675a2.26 2.26 0 0 1-.927-.457h.927z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#171796",
    d: "m10.48 8.126-.597.73.387 1.37c.375-.103 1.149-.195 1.149-.195l-.13-1.415z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#0193DD", d: "m9.004 8.514-.504.901.598 1.244 1.172-.422-.386-1.381z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#171796",
    d: "m13.53 8.126-.81.49-.105 1.416c.364.034 1.138.205 1.138.205l.375-1.38-.587-.731z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#0193DD",
    d: "m15.008 8.514-.892.342-.375 1.38c.375.103 1.161.423 1.161.423l.598-1.244zM12.006 8l-.715.616.129 1.415c.317-.022 1.184 0 1.184 0l.106-1.415L11.994 8z"
  }
));
Hr24.Size = 24;
Hr24.Title = "Hr";

export { Hr24 as default };
